import { render, staticRenderFns } from "./Statute.vue?vue&type=template&id=b2b6a37a&scoped=true&"
import script from "./Statute.vue?vue&type=script&lang=js&"
export * from "./Statute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b6a37a",
  null
  
)

export default component.exports